<template>
  <div>
    <Banner class="mb-0" />
    <Login
      class="mt-1"
      :isDialogOpen="showLoginDialog"
      title="Mobile Login"
      :defaultOfficeCode="defaultOfficeCode"
      @loggedIn="loggedInEvent"
    />
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'
import Login from '@/components/User/Login'
import Banner from '@/components/dashboard/Banner'
import { logout } from '../store/UserSession'
export default {
  name: 'LoginPage',
  components: { Banner, Login },
  props: {
    defaultOfficeCode: {
      type: String,
      default: null
    }
  },
  setup() {
    const router = useRouter()

    const showLoginDialog = ref(true)

    const initForm = () => {
      console.log({ loc: 'LoginPage/initForm' })
      logout()
      showLoginDialog.value = true
    }

    const loggedInEvent = () => {
      showLoginDialog.value = false
      loadHomePage()
      if (event.MustChangePassword) {
        confirm('must change password')
      }
    }

    const loadHomePage = () => {
      router.push({ name: 'dashboard' })
    }

    initForm()

    return {
      showLoginDialog,
      loggedInEvent
    }
  }
}
</script>
